export default __webpack_public_path__ + "static/media/pexels-nataliya-vaitkevich-5792327.e546b52d.jpg";